import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import RootApp from "./App"; // Include Tailwind CSS here

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <RootApp/>
    </React.StrictMode>,
);
